const SFormWrapper = ({ children, className }) => {
  return (
    <div className={`my-3 flex flex-col gap-2 text-gray-300 ${className}`}>
      {children}
    </div>
  )
}
export default SFormWrapper
